import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabrentalsinchennai() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Rentals in Chennai',
    heading: 'Aaryan Travels: Monthly Corporate Cab Rentals in Chennai',
    headingDescription: 'Aaryan Travels provides dependable Monthly Corporate Cab Rentals in Chennai for businesses, IT parks, manufacturing units, and executives who require consistent and professional transportation. Whether it’s daily office commute, client transfers, airport pickups from Chennai International Airport, or intercity corporate travel to Bengaluru or Pondicherry, our fleet of sedans, SUVs, and tempo travellers is available on fixed monthly contracts with flexible usage plans. With trained chauffeurs, GPS-enabled vehicles, punctual reporting, and hassle-free billing, we ensure smooth mobility across major corporate hubs like OMR, Guindy, Ambattur, and Siruseri. Aaryan Travels eliminates the need for daily bookings with well-managed long-term corporate cab rental solutions in Chennai.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is India’s longest urban beach, stretching over 13 kilometers along the Bay of Bengal. It is popular for sunrise walks, horse rides, and local street snacks like sundal and murukku. Monuments and statues along the promenade add cultural charm. The sea breeze and lively atmosphere attract tourists and locals alike. Marina Beach is Chennai’s iconic coastal escape."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a classic example of Dravidian architecture dedicated to Lord Shiva. Its vibrant gopuram is adorned with intricate sculptures depicting mythological tales. Devotees gather in large numbers during religious festivals like Panguni Peruvizha. Surrounding shops sell flowers, bangles, and prasadam. Kapaleeshwarar Temple is Chennai’s spiritual heritage landmark."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is the first English fortress in India. It now houses the Tamil Nadu Legislative Assembly and a museum displaying colonial-era artifacts. St. Mary’s Church inside is one of the oldest surviving Anglican churches in Asia. Fort St. George is Chennai’s historical cornerstone of colonial legacy."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a beautiful Gothic-style church built over the tomb of Saint Thomas the Apostle. Its stained-glass windows and serene interiors offer a peaceful experience. The underground chapel houses sacred relics of the saint. Located near the beach, it adds to the scenic beauty. Santhome Basilica is Chennai’s sacred Christian monument."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach is a quieter alternative to Marina Beach, favored by youngsters and families. The Karl Schmidt Memorial and nearby seaside cafes create a relaxed ambiance. The clean shoreline and calm waves make it ideal for peaceful evenings. Elliot’s Beach is Chennai’s serene seaside hangout."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is an impressive monument dedicated to the famous Tamil poet Thiruvalluvar. Built in the shape of a temple chariot, it features inscriptions of all 1,330 couplets from the Thirukkural. The auditorium within hosts cultural events and exhibitions. Valluvar Kottam is Chennai’s tribute to literature and wisdom."
  },
  {
    "title": "Government Museum, Egmore",
    "description": "The Government Museum in Egmore is one of India’s oldest museums, showcasing collections from archaeology, numismatics, zoology, and art. The Bronze Gallery and National Art Gallery attract history and art enthusiasts. The Indo-Saracenic architecture adds to its grandeur. It is an educational treasure for all ages. The museum is Chennai’s heritage hub of knowledge."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest yet richest urban forests. It is home to blackbucks, spotted deer, jackals, and numerous bird species. The adjoining Children’s Park and Snake Park make it ideal for family outings. Nature trails offer a refreshing escape from city life. Guindy Park is Chennai’s green sanctuary."
  },
  {
    "title": "Express Avenue Mall",
    "description": "Express Avenue Mall is a popular shopping and entertainment center offering international brands, multiplex cinemas, and a large food court. South India’s biggest gaming arcade makes it a hit among youngsters. The modern ambiance and accessibility make it a favorite hangout. Express Avenue is Chennai’s lifestyle hotspot."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Vandalur Zoo is India’s largest zoological park, covering over 1,500 acres. It houses tigers, lions, elephants, reptiles, and exotic birds. Safari rides and butterfly parks offer adventure and learning. The lush greenery makes it perfect for full-day excursions. Vandalur Zoo is Chennai’s wildlife wonderland."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Rentals in Chennai",
    "description": "Monthly Corporate Cab Rentals in Chennai provide businesses with a flexible and reliable transportation solution designed to meet ongoing corporate travel needs. Offering a wide range of premium vehicles and professional chauffeurs, this service ensures punctual, comfortable, and safe rides for employees and clients alike. Tailored subscription plans help companies manage their transportation budgets effectively, while real-time tracking and dedicated customer support enhance the overall experience."
  },
  {
    "name": "Chennai Corporate Monthly Cab Hire",
    "description": "Chennai Corporate Monthly Cab Hire offers customized rental plans that allow businesses to secure dependable transportation for their workforce on a monthly basis. With an emphasis on professionalism and efficiency, our fleet features well-maintained vehicles driven by experienced chauffeurs who understand corporate etiquette and the importance of timely arrivals."
  },
  {
    "name": "Business Cab Subscription Chennai",
    "description": "Business Cab Subscription Chennai is a convenient service designed to provide regular corporate cab rentals with flexible terms. This subscription model helps organizations streamline employee transportation, ensuring consistent availability of quality vehicles and drivers without the hassle of repeated bookings."
  },
  {
    "name": "Chauffeur Corporate Cab Monthly Chennai",
    "description": "Chauffeur Corporate Cab Monthly Chennai delivers premium chauffeur-driven vehicles on a monthly contract basis, combining luxury, comfort, and professionalism. Our drivers are trained to offer discreet, efficient, and courteous service, making every corporate commute stress-free and productive."
  },
  {
    "name": "Office Transport Chennai Monthly",
    "description": "Office Transport Chennai Monthly caters to companies seeking reliable monthly transport solutions for their staff. This service focuses on timely pickups and drop-offs, ensuring employees reach their workplaces punctually while enjoying a safe and comfortable commute."
  },
  {
    "name": "Staff Cab Chennai Monthly",
    "description": "Staff Cab Chennai Monthly provides convenient and affordable transportation options for company employees with monthly rental plans. The service features a variety of vehicle types to accommodate different group sizes and preferences, all driven by professional chauffeurs."
  },
  {
    "name": "Corporate Taxi Chennai Monthly",
    "description": "Corporate Taxi Chennai Monthly offers dependable monthly taxi rentals dedicated to business clients. Our vehicles are regularly serviced and come with experienced drivers who prioritize punctuality, safety, and customer satisfaction throughout your corporate travels."
  },
  {
    "name": "Corporate Vehicle Rental Chennai",
    "description": "Corporate Vehicle Rental Chennai provides a broad selection of rental cars specifically tailored to corporate needs. From sedans to SUVs, our vehicles are equipped with modern amenities and maintained to the highest standards, ensuring a smooth and comfortable ride for business purposes."
  },
  {
    "name": "Executive Corporate Cab Chennai",
    "description": "Executive Corporate Cab Chennai is designed for senior management and business executives who require a premium, reliable transport service. With luxury vehicles and professional chauffeurs trained in executive-level service, this offering guarantees discretion, comfort, and timely arrivals."
  },
  {
    "name": "Affordable Monthly Corporate Cab Chennai",
    "description": "Affordable Monthly Corporate Cab Chennai focuses on providing cost-effective corporate cab rental solutions without compromising on quality or professionalism. Our transparent pricing and flexible plans make it easier for businesses to manage their transportation needs within budget."
  },
  {
    "name": "Corporate Car Leasing Chennai",
    "description": "Corporate Car Leasing Chennai offers long-term leasing options for businesses looking to secure vehicles for corporate use. Our leasing plans include maintenance, insurance, and driver services, providing a hassle-free alternative to traditional rentals."
  },
  {
    "name": "Online Corporate Cab Chennai",
    "description": "Online Corporate Cab Chennai enables businesses to easily book and manage their corporate cab rentals through a user-friendly digital platform. With instant booking confirmations, fare transparency, and real-time tracking, this service streamlines the corporate travel experience."
  },
  {
    "name": "Monthly Business Cab Chennai",
    "description": "Monthly Business Cab Chennai caters to companies requiring regular transportation solutions with monthly rental agreements. Our service guarantees consistent availability of well-maintained vehicles and professional drivers, ensuring smooth and reliable travel for business operations."
  },
  {
    "name": "Long Term Corporate Cab Chennai",
    "description": "Long Term Corporate Cab Chennai provides extended rental contracts for businesses with ongoing transportation needs. Offering cost savings and priority service, this solution is ideal for companies seeking stable, high-quality corporate transportation over several months."
  },
  {
    "name": "Corporate Transport Chennai",
    "description": "Corporate Transport Chennai delivers comprehensive transportation solutions for businesses, including employee shuttles, client pickups, and event transportation. With a focus on professionalism, safety, and timeliness, our service supports diverse corporate travel requirements efficiently."
  }
],
"tableData": [
  ["Monthly Corporate Cab Rentals in Chennai", "Chennai Corporate Monthly Cab Hire"],
  ["Business Cab Subscription Chennai", "Chauffeur Corporate Cab Monthly Chennai"],
  ["Office Transport Chennai Monthly", "Staff Cab Chennai Monthly"],
  ["Corporate Taxi Chennai Monthly", "Corporate Vehicle Rental Chennai"],
  ["Executive Corporate Cab Chennai", "Affordable Monthly Corporate Cab Chennai"],
  ["Corporate Car Leasing Chennai", "Online Corporate Cab Chennai"],
  ["Monthly Business Cab Chennai", "Long Term Corporate Cab Chennai"],
  ["Corporate Transport Chennai", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Monthly Corporate Cab Rentals in Chennai",
    "WhyChoosedescription": "Aaryan Travels offers dependable monthly corporate cab rentals in Chennai, designed for smooth and consistent business travel."
  },
  {
    "WhyChooseheading": "Punctual and Professional Chauffeurs",
    "WhyChoosedescription": "Our trained drivers ensure timely pickups and drop-offs to keep your corporate schedule running efficiently."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel comfortably in sanitized, air-conditioned cabs maintained to high standards for daily corporate use."
  },
  {
    "WhyChooseheading": "Drivers Familiar with Chennai Routes",
    "WhyChoosedescription": "Our experienced chauffeurs know Chennai’s roads and traffic patterns for faster, stress-free commutes."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed monthly billing that includes all essentials—fuel, tolls, and driver fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporates",
    "WhyChoosedescription": "Our dedicated support team is always available to handle bookings, schedule changes, and urgent requests."
  },
  {
    "WhyChooseheading": "Customizable Plans to Suit Your Business Needs",
    "WhyChoosedescription": "Choose from a variety of vehicle types and plan durations that align with your company's travel requirements."
  },
  {
    "WhyChooseheading": "Dedicated Cab Services for Corporates",
    "WhyChoosedescription": "Get priority service with dedicated vehicles and drivers assigned exclusively for your organization."
  }
]












  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab rentals in Chennai?',
    answer: 'Yes, Aaryan Travels provides reliable and flexible monthly corporate cab rental plans in Chennai, ideal for regular employee travel and business needs.',
  },
  {
    question: 'How can I book monthly corporate cab rentals in Chennai with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate rentals in Chennai?',
    answer: 'Aaryan Travels offers a fleet of well-maintained sedans, SUVs, and premium cars based on your corporate requirements.',
  },
  {
    question: 'Are drivers experienced and trained for corporate cab services in Chennai?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to handle corporate travel across Chennai.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for monthly rentals?',
    answer: 'Yes, we allow full customization of pickup and drop-off points anywhere within Chennai and nearby industrial or tech zones.',
  },
  {
    question: 'Is the monthly corporate cab rental service available 24x7 in Chennai?',
    answer: 'Yes, Aaryan Travels operates 24x7 to meet the demands of dynamic business schedules and shift timings.',
  },
  {
    question: 'Are safety and hygiene protocols followed for monthly corporate cabs?',
    answer: 'Yes, all our vehicles are sanitized daily, and our drivers adhere to strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are available for monthly corporate cab rentals in Chennai?',
    answer: 'We accept payments through corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the rental period?',
    answer: 'Yes, Aaryan Travels provides 24x7 customer support for all clients throughout the rental duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. S. Balakrishnan',
    feedback: 'Aaryan Travels has been our go-to partner for corporate cab rentals in Chennai. Reliable, punctual, and professional service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meena Krishnan',
    feedback: 'We’ve been using Aaryan Travels’ monthly corporate cab service in Chennai for our staff — excellent experience so far.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const monthlyCorporateChennaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Rentals in Chennai",
  "description": "Aaryan Travels offers monthly corporate cab rentals in Chennai with chauffeur-driven vehicles for business travel, staff transport, and office commute needs.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "serviceType": "Monthly Corporate Cab Rental Service",
  "keywords": "Monthly Corporate Cab Rentals in Chennai, Chennai Corporate Monthly Cab Hire, Business Cab Subscription Chennai, Chauffeur Corporate Cab Monthly Chennai, Office Transport Chennai Monthly, Staff Cab Chennai Monthly, Corporate Taxi Chennai Monthly, Corporate Vehicle Rental Chennai, Executive Corporate Cab Chennai, Affordable Monthly Corporate Cab Chennai, Corporate Car Leasing Chennai, Online Corporate Cab Chennai, Monthly Business Cab Chennai, Long Term Corporate Cab Chennai, Corporate Transport Chennai"
};






  return (
    <div>

<Helmet>
  <title>Monthly Corporate Cab Rentals in Chennai | Business Cab Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book monthly corporate cab rentals in Chennai with Aaryan Travels. Chauffeur-driven vehicles for staff transport, office commute, and business travel."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Rentals in Chennai, Chennai Corporate Monthly Cab Hire, Business Cab Subscription Chennai, Chauffeur Corporate Cab Monthly Chennai, Office Transport Chennai Monthly, Staff Cab Chennai Monthly, Corporate Taxi Chennai Monthly, Corporate Vehicle Rental Chennai, Executive Corporate Cab Chennai, Affordable Monthly Corporate Cab Chennai, Corporate Car Leasing Chennai, Online Corporate Cab Chennai, Monthly Business Cab Chennai, Long Term Corporate Cab Chennai, Corporate Transport Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateChennaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabrentalsinchennai;